import React from "react";

import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemp from "./WeatherTemp";

import "./WeatherInfo.css";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div class="row">
        <div class="col-7 description-city-weather">
          <h2>{props.data.city}</h2>
          <span> Last update: </span>
          <FormattedDate date={props.data.date} />{" "}
          <div>{props.data.description}</div>
        </div>
        <div className="col-2 weather-icon">
          <WeatherIcon code={props.data.icon} size={80} />
        </div>{" "}
        <div class="col-3">
          <WeatherTemp celsius={props.data.temperature} />
        </div>
      </div>
      <ul class="d-flex justify-content-around">
        <li>
          <i class="fa-solid fa-temperature-three-quarters weather-stats-icon"></i>
          <div className="detail">{Math.round(props.data.feelsLike)}°C</div>
          Feels like
        </li>

        <li>
          <i class="fa-solid fa-droplet weather-stats-icon"></i>
          <div className="detail">{props.data.humidity}%</div>
          Humidity
        </li>
        <li>
          <i class="fa-solid fa-wind"></i>
          <div className="detail">{Math.round(props.data.wind)} m/s</div>Wind
        </li>
        <li>
          <i class="fa-gauge fa-solid"></i>
          <div className="detail">{Math.round(props.data.pressure)} </div>
          Pressure
        </li>
      </ul>
    </div>
  );
}
